export const styles = {
  maxWidth: '1170px',
}
